/* eslint-disable no-unused-vars */
/* eslint-disable valid-jsdoc */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  INVALIDATE_USERS,
  INVALIDATE_HOTELIERS,
  INVALIDATE_HOTEL,
} from "./invalidationTags";
import {
  logout,
  setAccessToken,
} from "redux/features/userSliceWithTokenValidation";
import { authentificate, DEFAULT_API } from "routes/api/endpoints";

const baseQuery = fetchBaseQuery({
  baseUrl: DEFAULT_API,
  prepareHeaders: (headers, { getState }) => {
    const state = getState();
    const accessToken = state?.persist.auth?.accessToken || null;

    if (accessToken) {
      headers.set("Authorization", `Bearer ${accessToken}`);
    }
    return headers;
  },
});

/**
 *=====================================================
 *
 * Verification de la validite du token
 *
 * ====================================================
 */
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    const refreshToken = api.getState().auth?.refreshToken;

    if (refreshToken) {
      const refreshResult = await baseQuery(
        {
          url: authentificate.onRefreshToken(),
          method: "POST",
          body: JSON.stringify({ refresh: refreshToken }),
          headers: {
            "Content-Type": "application/json",
          },
        },
        api,
        extraOptions,
      );

      if (refreshResult.data) {
        // Update the access token in the Redux store
        api.dispatch(setAccessToken(refreshResult.data.accessToken));

        // Retry the original request with the new access token
        result = await baseQuery(args, api, extraOptions);
      } else {
        // If token refresh fails, log out
        api.dispatch(logout());
      }
    } else {
      // No refresh token available, log out
      api.dispatch(logout());
    }
  }

  return result;
};

/**
 *=====================================================
 *
 * OPTION1: Base api avec validation du token
 *
 * ====================================================
 */
export const rxdApi = createApi({
  baseQuery: baseQueryWithReauth,
  refetchOnReconnect: true,
  // keepUnusedDataFor: 50,
  reducerPath: "safmo-reducerPath",
  endpoints: () => ({}),
});

/**
 *=====================================================
 *
 * OPTION2: Base api sans validation du token
 *
 * ====================================================
 */
// export const rxdApi = createApi({
//     baseQuery: fetchBaseQuery({ baseUrl: DEFAULT_API }),
//     refetchOnReconnect: true,
//     keepUnusedDataFor: 86400,
//     reducerPath: 'path',
//     endpoints: () => ({}),
// });

export const ApiMananger = rxdApi.enhanceEndpoints({
  addTagTypes: [INVALIDATE_USERS, INVALIDATE_HOTELIERS, "HOTELIERS"],
  endpoints: () => {},
});
